// Inline SVG icons. Each is a render function so callers pass a tint color.
// Sized to roughly match design_handoff_ballingo/ui.jsx.

export const Icons = {
  flame: (c = '#FF7A45') => (
    <svg width="22" height="22" viewBox="0 0 24 24">
      <path d="M12 2 C12 7, 7 7, 7 13 a5 5 0 0 0 10 0 c0-3 -2-5 -3-7 -1 1 -1 2 -2 4 0-3 0-5 0-8z"
            fill={c} stroke="#B85A2A" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M12 12 c0 2 -2 3 -2 5 a2.5 2.5 0 0 0 5 0 c0 -2 -1 -3 -3 -5z" fill="#FFD27A" />
    </svg>
  ),
  gem: (c = '#2D5BFF') => (
    <svg width="20" height="20" viewBox="0 0 24 24">
      <path d="M5 9 L12 3 L19 9 L12 21 Z" fill={c} stroke="#1E40C9" strokeWidth="1.4" strokeLinejoin="round" />
      <path d="M5 9 L19 9 M9 9 L12 21 M15 9 L12 21 M12 3 L9 9 M12 3 L15 9"
            stroke="#fff" strokeWidth="1" strokeOpacity="0.7" />
    </svg>
  ),
  heart: (c = '#E63946') => (
    <svg width="22" height="22" viewBox="0 0 24 24">
      <path d="M12 21 C 4 14, 4 7, 8 5 c 2 -1 3 0 4 2 c 1 -2 2 -3 4 -2 c 4 2 4 9 -4 16 z"
            fill={c} stroke="#B82A36" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
  ),
  star: (c = '#FFC857') => (
    <svg width="18" height="18" viewBox="0 0 24 24">
      <path d="M12 2 L14.6 8.6 L22 9.3 L16.5 14 L18 21 L12 17.3 L6 21 L7.5 14 L2 9.3 L9.4 8.6 Z"
            fill={c} stroke="#D69A1F" strokeWidth="1.2" strokeLinejoin="round" />
    </svg>
  ),
  book: () => (
    <svg width="30" height="30" viewBox="0 0 32 32">
      <rect x="6" y="6" width="20" height="22" rx="2" fill="#fff" stroke="#1A1A2E" strokeWidth="2" />
      <path d="M10 12 H22 M10 16 H22 M10 20 H18" stroke="#1A1A2E" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  ribbon: () => (
    <svg width="30" height="30" viewBox="0 0 32 32">
      <path d="M16 4 L8 12 L16 20 L24 12 Z" fill="#fff" stroke="#1A1A2E" strokeWidth="2" strokeLinejoin="round" />
      <path d="M8 12 L4 28 L12 24 L16 28 L20 24 L28 28 L24 12" fill="#fff" stroke="#1A1A2E" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  ),
  chest: () => (
    <svg width="30" height="30" viewBox="0 0 32 32">
      <rect x="5" y="10" width="22" height="16" rx="2" fill="#fff" stroke="#1A1A2E" strokeWidth="2" />
      <path d="M5 14 Q5 6 16 6 Q27 6 27 14" fill="#fff" stroke="#1A1A2E" strokeWidth="2" />
      <rect x="14" y="14" width="4" height="6" rx="1" fill="#1A1A2E" />
    </svg>
  ),
  trophy: () => (
    <svg width="30" height="30" viewBox="0 0 32 32">
      <path d="M10 6 H22 V14 a6 6 0 0 1 -12 0 Z" fill="#fff" stroke="#1A1A2E" strokeWidth="2" />
      <path d="M10 8 H4 v4 a4 4 0 0 0 6 4 M22 8 h6 v4 a4 4 0 0 1 -6 4" stroke="#1A1A2E" strokeWidth="2" fill="none" />
      <rect x="12" y="20" width="8" height="3" fill="#1A1A2E" />
      <rect x="9" y="23" width="14" height="3" fill="#1A1A2E" />
    </svg>
  ),
  lock: () => (
    <svg width="22" height="22" viewBox="0 0 24 24">
      <rect x="5" y="11" width="14" height="10" rx="2" fill="#1A1A2E" />
      <path d="M8 11 V8 a4 4 0 0 1 8 0 V11" stroke="#1A1A2E" strokeWidth="2" fill="none" />
    </svg>
  ),
  mic: (c = '#fff') => (
    <svg width="36" height="36" viewBox="0 0 24 24">
      <rect x="9" y="3" width="6" height="12" rx="3" fill={c} />
      <path d="M5 11 a7 7 0 0 0 14 0 M12 18 V21 M9 21 H15" stroke={c} strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  ),
  speaker: (c = '#fff') => (
    <svg width="34" height="34" viewBox="0 0 24 24">
      <path d="M3 9v6h4l5 4V5L7 9H3z" fill={c} />
      <path d="M14.5 8 Q18 12 14.5 16 M17 5.5 Q22 12 17 18.5" stroke={c} strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  ),
  close: (c = '#B7A892') => (
    <svg width="26" height="26" viewBox="0 0 24 24">
      <path d="M6 6 L18 18 M18 6 L6 18" stroke={c} strokeWidth="3" strokeLinecap="round" />
    </svg>
  ),
  home: (c) => (
    <svg width="26" height="26" viewBox="0 0 24 24">
      <path d="M4 12 L12 4 L20 12 V20 H4 Z" fill={c} stroke={c} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  ),
  league: (c) => (
    <svg width="26" height="26" viewBox="0 0 24 24">
      <path d="M8 4 H16 V11 a4 4 0 0 1 -8 0 Z M5 5 H8 v4 a3 3 0 0 1 -3 3 M19 5 H16 v4 a3 3 0 0 0 3 3"
            stroke={c} strokeWidth="2" fill="none" />
      <rect x="9" y="16" width="6" height="2" fill={c} />
      <rect x="7" y="18" width="10" height="2" fill={c} />
    </svg>
  ),
  quest: (c) => (
    <svg width="26" height="26" viewBox="0 0 24 24">
      <rect x="5" y="4" width="14" height="17" rx="2" stroke={c} strokeWidth="2" fill="none" />
      <path d="M8 9 H16 M8 13 H16 M8 17 H13" stroke={c} strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  shop: (c) => (
    <svg width="26" height="26" viewBox="0 0 24 24">
      <path d="M4 8 H20 L18 20 H6 Z" stroke={c} strokeWidth="2" fill="none" strokeLinejoin="round" />
      <path d="M9 8 V6 a3 3 0 0 1 6 0 V8" stroke={c} strokeWidth="2" fill="none" />
    </svg>
  ),
  user: (c) => (
    <svg width="26" height="26" viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="4" stroke={c} strokeWidth="2" fill="none" />
      <path d="M4 21 a8 8 0 0 1 16 0" stroke={c} strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  ),
  cog: (c = '#7A6655') => (
    <svg width="22" height="22" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="3" stroke={c} strokeWidth="2" fill="none" />
      <path d="M12 2 V5 M12 19 V22 M2 12 H5 M19 12 H22 M4.9 4.9 L7 7 M17 17 L19.1 19.1 M4.9 19.1 L7 17 M17 7 L19.1 4.9"
            stroke={c} strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
};
